import React from "react";
import "../../styles/Project.css";
const CustomCheckBox = ({
  title,
  id,
  lblClass = "h-8 ",
  containerClass = "w-1/2",
  checked,
  onChange,
}) => {
  return (
    <div className={containerClass}>
      <input
        type="checkbox"
        id={id}
        className="appearance-none hidden w-full h-full custom-checkbox "
        onChange={onChange}
        checked={checked}
      />
      <label
        htmlFor={id}
        className={`rounded-lg flex items-center justify-center font-medium
              w-full ${lblClass} bg-custom-gray-200 cursor-pointer custom-checkbox-label text-sm transition-all duration-300`}
      >
        {title}
      </label>
    </div>
  );
};

export default CustomCheckBox;
